import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { filter } from 'rxjs/operators';
import { HubStatus } from '@app/constants';
import { LinqSocketsService } from '@app/shared/sockets/services';
import { HubData, SocketsConnection } from '@app/shared/sockets/shared/interfaces';

@Injectable()
export class SocketService {
	notification$ = new Subject<HubData>();

	starting$ = this.notification$.pipe(filter((notification) => notification.Status === HubStatus.Starting));
	info$ = this.notification$.pipe(filter((notification) => notification.Status === HubStatus.Info));
	success$ = this.notification$.pipe(filter((notification) => notification.Status === HubStatus.Success));
	error$ = this.notification$.pipe(filter((notification) => notification.Status === HubStatus.Error));

	constructor(private readonly linqSocketsService: LinqSocketsService) {
		this.linqSocketsService.connectionSubject$.subscribe((connection: SocketsConnection) => this.onConnectionChange(connection));
	}

	onConnectionChange = (connection: SocketsConnection): void => {
		if (connection) {
			connection.subscribe('progress', this.onProgressMessage);
		}
	};

	onProgressMessage = (notification: HubData): void => {
		this.notification$.next(notification);
	};
}
